var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"_btn-favourite",class:{'border border--blue': _vm.border},style:({
            fontSize: _vm.size,
            width: _vm.width,
            height: _vm.height
       }),attrs:{"ripple":false,"disabled":_vm.$auth.user().id === _vm.item.user_from_id,"icon":""},on:{"click":_vm.favourites}},[(_vm.$auth.user().id === _vm.item.user_from_id)?_c('span',{staticClass:"icon-NG_ACCOUNT primary--text"}):_c('span',{staticClass:"primary--text",class:("icon-NG_FAVOURITES" + (_vm.item.is_favorite ? '_FILL':''))})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-977c5112","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-buttons/app-btn-favourite.vue
// module id = null
// module chunks = 